import React, {
  CSSProperties, useMemo,
} from 'react';
import styles from './selectInput.module.css';
import { DropDownMenuItem } from '../DropdownMenu';
import SharedAutoComplete from '../SharedAutoComplete/SharedAutoComplete';

export type SelectValueType = string | number | readonly string[] | undefined;

interface SelectInputProps<T> {
  className?: string,
  value: T | undefined | null,
  disabled?: boolean,
  style?: CSSProperties,
  options?: DropDownMenuItem<T>[],
  onChange: (value: T)=> void
  disablePortal?: boolean
  popperZIndex?: number
  autoSetValueOnSelect?: boolean
}

function SelectInput<T=string>({
  className = '', value, options = [], disabled = false, style = {}, onChange, disablePortal, popperZIndex, autoSetValueOnSelect = true,
}: SelectInputProps<T>) {
  const text = useMemo(() => options.find((item) => item.value === value)?.text || '', [options, value]);

  return (
    <div className={[styles.container, className].join(' ')} style={style}>
      <SharedAutoComplete
        value={text}
        disabled={disabled}
        options={options}
        onSelect={({ value: v }) => onChange(v)}
        disablePortal={disablePortal}
        popperZIndex={popperZIndex}
        inputReadOnly
        autoSetValueOnSelect={autoSetValueOnSelect}
      />
    </div>
  );
}

export default SelectInput;
